import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useRegisterMutation } from '../../redux/services/authApi';
import CustomButton from '../mini/CustomButton';
import DashHeader from '../mini/DashHeader';

const AddRider = () => {
    
    const [ fullName, setFullName ] = useState('')
    const [ email, setEmail ] = useState('')
    const [ phone, setPhone ] = useState('')
    const [registerAdmin, {isLoading}] = useRegisterMutation()
    const adminEmail = useSelector((state) => state.auth?.user?.email)
    
    let handleInput = (e) => {
        switch (e.target.id) {
            case 'fName':
            setFullName(e.target.value);
            break;
            
            case 'email':
            setEmail(e.target.value);
            break;
            
            case 'phone':
            setPhone(e.target.value);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    const submit = async (e) => {
        e.preventDefault()

        if (!fullName || !email || !phone) 
            return toast.error("All fields are required", {
                position: toast.POSITION.TOP_RIGHT
            })

        await registerAdmin({ email, fullName, phone, adminEmail, password: "password", userType: 'admin' })
            .unwrap()
            .then((response) => {
                toast.success(response?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                setFullName('')
                setPhone('')
                setEmail('')
            })
            .catch((error) => {
                console.log(error)
                toast.error(error?.data?.message || error?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
    }

    return (
        <>
            <div className="pull-up">
                <DashHeader title="Create Admin" />
                <div className="content mt-5">
                    <div className="col-md-8 my-md-0 my-3">
                        <form onSubmit={submit} autoComplete={"off"}>

                            <div className="form-group mb-4 me-4">
                                <label htmlFor="fName" className="mb-2 fw-normal">Full Name</label>
                                <div className="input form-control">
                                    <input type="text" id="fName" className="w-100 p-2 ps-0" onChange={handleInput} value={fullName} />
                                </div>
                            </div>
                            <div className="form-group mb-4 me-4">
                                <label htmlFor="email" className="mb-2 fw-normal">Email Address</label>
                                <div className="input form-control">
                                    <input type="email" id="email" className="w-100 p-2 ps-0" onChange={handleInput} value={email} />
                                </div>
                            </div>
                            <div className="form-group mb-4 me-4">
                                <label htmlFor="phone" className="mb-2 fw-normal">Phone Number</label>
                                <div className="input form-control">
                                    <input type="text" id="phone" className="w-100 p-2 ps-0" onChange={handleInput} value={phone} />
                                </div>
                            </div>

                            <CustomButton loading={isLoading} width={"208px"} title={"create new admin"} />
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddRider
